import { authApi } from "@/lib/api";

export interface DevelopmentUser {
    id: number;
    name: string;
    email: string;
    avatar?: string | null;
    roles?: string[];
}

let usersPromise: Promise<DevelopmentUser[]> | null = null;

export const setDevelopmentItUsers = (users: DevelopmentUser[]): void => {
    usersPromise = Promise.resolve(users);
};

export const getDevelopmentUsers = (): Promise<DevelopmentUser[]> => {
    if(!usersPromise){
        usersPromise = authApi.users().then((response) => {
            if(!response.result || !Array.isArray(response.data)){
                return [];
            }

            return response.data;
        }).catch((error) => {
            usersPromise = null;
            throw error;
        });
    }

    return usersPromise;
};

export const getDevelopmentItUsers = (): Promise<DevelopmentUser[]> => (
    getDevelopmentUsers().then((users) => users.filter((user) => user.roles?.includes("it")))
);
